// src/components/Loader.js
import React from 'react';
import { Spin } from 'antd';

const Loader = () => (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
        <Spin size="large" tip="Loading..." />
    </div>
);

export default Loader;
